import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCognizantComponent } from './simple-icons-cognizant.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCognizantComponent ],
    exports:      [ SimpleIconsCognizantComponent ],
    bootstrap:    []
})
export class SimpleIconsCognizantModule {}
